/* global document */

import analytics from '@finn-no/analytics';
import './styles.css';

document.addEventListener('DOMContentLoaded', () => {
    const livinlink = document.getElementById('livinlink');
    if (livinlink) {
        livinlink.addEventListener(
            'click',
            () => {
                analytics.trackEvent({
                    analyticsName: 'navigation.go-to-livvin.click',
                    eventFlags: 'start,ltp',
                });
            },
            false
        );
    }
    const searchLinks = document.getElementById('search-links');
    if (searchLinks) {
        searchLinks.querySelectorAll('a').forEach(el => {
            el.addEventListener('click', () => {
                const category = el.getAttribute('data-category');
                analytics.trackEventLater({
                    analyticsName: 'navigation.filter-by-category.click',
                    stringValue: `location:bapfront,category:${category}`,
                });
            });
        });
    }
});
